import { gql } from "@apollo/client";

export const CREATE_AML_RULE_REFERENCE_EXCLUSION = gql`
  mutation createAmlRuleReferenceExclusion(
    $input: CreateAmlRuleExclusionInput!
  ) {
    aml {
      createAmlRuleReferenceExclusion(input: $input) {
        id
        success
      }
    }
  }
`;
